const names = {
  accentBlue: '--color-accent-blue',
  oldBlue: '--color-old-blue',
  blue: '--color-blue',
  bluePurple: '--color-blue-purple',
  danger: '--color-danger',
  gray: '--color-gray',
  grayLight: '--color-gray-light',
  grayLighter: '--color-gray-lighter',
  darkGray: '--color-dark-gray',
  green: '--color-green',
  greenLighter: '--color-green-lighter',
  lightBlue: '--color-light-blue',
  orange: '--color-orange',
  orangeLighter: '--color-orange-lighter',
  palePurple: '--color-pale-purple',
  palePurpleLight: '--color-pale-purple-light',
  red: '--color-red',
  dustRed: '--color-dust-red',
  redLight: '--color-red-light',
  rose: '--color-rose',
  skyBlue: '--color-sky-blue',
  polarGreen: '--color-green-7',
};

const base = Object.create(null);
Object.assign(base, names);

const handler = {
  get: (target: object, prop: string) => {
    if (!Reflect.has(target, prop)) return '';
    return getComputedStyle(document.body).getPropertyValue(
      Reflect.get(target, prop),
    );
  },
  set: () => false,
};

const colorFactory = (): Record<keyof typeof names, string> => {
  return new Proxy(base, handler);
};

const colors = colorFactory();

export { colors };
